<h1 mat-dialog-title>
  <mat-icon style="vertical-align: middle; margin-right: 5px">exit_to_app</mat-icon>
  Logg av
</h1>
<mat-dialog-content>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Nei</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ja</button>
</mat-dialog-actions>